import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import TechImagePanel from '@/components/feature/TechImagePanel';
import Hero from './components/Hero';
import SupplyChain from './components/SupplyChain';
import ServiceBusiness from './components/ServiceBusiness';

export default function SupplyService() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="九畴云铺供应链与服务 | 农产品数字化上行与数字服务经济"
        description="九畴云铺供应链让农产品从产品变成数字商品，服务业务让县域形成商品经济加服务经济的双轮驱动，对应数商兴农与农产品出村进城方向。"
        keywords="九畴云铺,供应链,服务业务,数商兴农,农产品出村进城,数字经济"
        path="/jiuchou/supply-service"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '九畴云铺供应链与服务',
          description: '农产品数字化上行与数字服务经济',
        }}
      />
      <main>
        <Hero />
        <SupplyChain />
        <TechImagePanel
          eyebrow="供给数字化"
          title="从产地到数字货架，从卖商品到卖服务"
          desc="供应链让农产品数字化上行，服务业务让县域形成「商品经济 + 服务经济」双轮驱动。"
          chips={['数商兴农', '农产品出村进城', 'ePin 溯源', '服务经济']}
          stats={[
            { value: 'ePin', label: '一物一码' },
            { value: '8 类', label: '服务类型' },
            { value: '双轮', label: '商品+服务' },
          ]}
          imageUrl="https://readdy.ai/api/search-image?query=Abstract%20agricultural%20origin%20to%20digital%20shelf%20flow%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20stream%20connecting%20farm%20field%20silhouette%20to%20cloud%20storefront%20and%20consumer%20node%2C%20rural%20digital%20economy%20supply%20chain%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=900&seq=jiuchou-panel-supply&orientation=landscape"
          imageAlt="九畴云铺 供应链与服务"
        />
        <ServiceBusiness />
      </main>
      <Footer />
    </div>
  );
}